export default __webpack_public_path__ + "static/media/DocumentDownload.4fc4bd96.svg";